<template>
  <div :class="$style.processing">
    <div :class="$style.processingLoader">
      <svg v-svg
           :class="$style.loadingIcon"
           symbol="processing-icon" />
    </div>

    <KioskMessageTitle :class="$style.processingText"
                       title="Processing..." />
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskMessageTitle from '@/components/KioskMessageTitle';

@Component({
  components: {
    KioskMessageTitle,
  },
})
export default class KioskPayment extends Vue {}
</script>

<style lang="scss" module>
.processingLoader {
  width: 238px;
  height: 238px;
  margin: 0 auto;
  animation: loader 3s linear infinite;
  .loadingIcon {
    width: 238px;
    height: 238px;
  }
}

.processingText {
  margin-top: 52px;
}

@keyframes loader {
  from {
    transform: rotateZ(0);
  }
  50% {
    transform: rotateZ(180deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskSpinner.vue